import React from 'react';
import PropTypes from 'prop-types';
// Utilities
import Attribution from 'Utils/content/attribution';
import { getAuthorUrl } from 'Utils/content/flipboard-urls';
import { USAGE_EVENT_NAMES } from 'Utils/analytics/usage';
// Components
import WebLink from '../../components/web-link';
import AuthorAvatar from '../../components/attribution/author-avatar';
import AuthorAttribution from '../../components/attribution/author';

import connector from 'Utils/connector';
import connectUsageSetNavFrom from 'Webapp/shared/app/connectors/connectUsageSetNavFrom';

function StoryboardIntro({ item, usageSetNavFrom }) {
  const onProfileClick = function () {
    usageSetNavFrom('storyboard-layout');
  };

  const author = Attribution.getAuthor(item);

  return (
    <div className="storyboard-intro">
      <p className="storyboard-intro__text ui-text--body">{item.text}</p>
      <div className="storyboard-post__author-attribution">
        <WebLink
          href={getAuthorUrl(author)}
          onClick={onProfileClick}
          navFromEventName={USAGE_EVENT_NAMES.SECTION_ENTER}
        >
          <AuthorAvatar author={author} />
        </WebLink>
        <div className="storyboard-intro__author-attribution-text ui-text--supporting">
          <AuthorAttribution author={author} onProfileClick={onProfileClick} />
        </div>
      </div>
    </div>
  );
}

StoryboardIntro.propTypes = {
  item: PropTypes.object.isRequired,
  usageSetNavFrom: PropTypes.func.isRequired,
};

export default connector(connectUsageSetNavFrom)(StoryboardIntro);
